/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidacyProfileEntryStorePathParams,
	CandidacyProfileEntryStoreRequest,
	CandidacyProfileEntryStoreResponse,
} from '../types/CandidacyProfileEntryStore'

/**
 * POST /candidate-center/organisations/:organisation/candidacies/:candidacy/profile/:section
 * @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyProfileEntryController.php CandidacyProfileEntryController::store
 */
export async function candidacyProfileEntryStore(
	organisation: CandidacyProfileEntryStorePathParams['organisation'],
	candidacy: CandidacyProfileEntryStorePathParams['candidacy'],
	section: CandidacyProfileEntryStorePathParams['section'],
	data: CandidacyProfileEntryStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidacyProfileEntryStoreResponse>> {
	return axiosInstance.post(
		`/candidate-center/organisations/${organisation}/candidacies/${candidacy}/profile/${section}`,
		data,
		config,
	)
}
